import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  imageContainer: {
    border: '2px dashed #ccc',
    borderRadius: '8px',
    padding: '16px',
    textAlign: 'center',
    marginTop: '8px',
    cursor: 'pointer',
    transition: '0.2s',
    '&:hover': {
      borderColor: '#2C9DC9',
    },
  },
  imageWrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  imagePreview: {
    maxWidth: '150px',
    height: '150px',
    objectFit: 'cover',
    borderRadius: '8px',
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
  },
  clearButton: {
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    padding: '2px',
    color: '#fff',
    filter: 'drop-shadow(0 0 2px rgba(0, 0, 0, 0.8))',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  uploadButton: {
    marginTop: '8px',
  },
  dragginBorder: {
    border: '2px dashed #3f51b5',
  },
}));

export default useStyles;
